/**
 * Opacity Tokens
 *
 * `disabled` is the disabled fade, 50%. A checked, disabled Checkbox, Radio or
 * Switch takes it too, faded once as a whole control (Ardhi Q1/Q2, 2026-10-30:
 * one opacity token, Figma's `opacity/disabled`).
 *
 * @see DS-002-spacing.md
 */
export const opacity = {
  disabled: 0.5,
} as const;

export type OpacityKey = keyof typeof opacity;
